/* 司馬懿（字仲達） */
import { defineHero, P, D } from '../define.ts';

export default defineHero({
  id: 'simayi', name: '司馬懿', sub: '字仲達', faction: 'wei', role: '法師', weapon: 'staff',
  look: { head: 'guan', robe: true, eye: 'narrow', beard: 'goatee', fx: '#b98cff', c: { cloth: '#3a2a5a', sleeve: '#3a2a5a', armor: '#8a6ad8', trim: '#c9a2ff', pole: '#2a2030' } },
  skills: [
    ['焰擊波', 'fire', '直線連環爆炸，造成 {75/125/175/275} 傷害並暈眩 1.5 秒。', { x: { k: 'line', dmg: [75, 125, 175, 275], cc: { stun: 1.5 }, rad: 40, speed: 900, shape: 'fire' }, aim: D(480, 40) }],
    ['火雨術', 'volley', '一波火雨造成 {70/115/160/205} 傷害，並繼續燃燒 3 秒，每秒 {10/20/30/40}。', { x: { k: 'aoe', dmg: [70, 115, 160, 205], r: 200, burnZone: { dps: [10, 20, 30, 40], dur: 3 }, fx: 'fire' }, aim: P(520, 200) }],
    ['液態火', 'passive', '普攻讓目標燃燒，每秒 {5/10/15/20} 傷害。', { pv: { burnHit: [5, 10, 15, 20] } }],
    ['星落', 'thunder', '詠唱 1.75 秒後隕石墜落，造成 180 傷害並震暈 1.5 秒。', { x: { k: 'aoe', dmg: [180, 180, 180], r: 220, cc: { stun: 1.5 }, delay: 1.75, ground: true, fx: 'fire' }, aim: P(560, 220), shout: '星落！' }],
  ],
});
